import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GlobalConstants {

    public baseUrl: string;
    public locale: any;
    public format: any;
    public agendaItemStatus: any;
    private sessionStorage = sessionStorage;

    constructor() {
        this.baseUrl = environment.tcmURL; // dev
        this.format = {
            date: 'MM/DD/YYYY',
            time: 'h:mm A',
            datePipe: 'MM/dd/yyyy',
            timePipe: 'h:mm a',
            cardDateFormat: 'MMM D, YYYY'
        };
        this.locale = {
            enus: 'en-US'
        };


    }
    clearSessionStorage = () => {
        this.sessionStorage.clear();
    }

    /**
     * Method to set config in sessionstroge
     * @param key string
     * @param value any
     */
    setSessionStorage = (key: string, value: any) => {
        return this.sessionStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * Method to get data from session stroge
     * @param key string
     * @returns data
     */
    getSessionStorage: any = (key: string) => {
        const objJson: any = this.sessionStorage.getItem(key);
        return objJson !== null ? JSON.parse(objJson) : null;

    }

    removeSessionStorage: any = (key: string) => {
        this.sessionStorage.removeItem(key);
    }

}
